/**
 * Merchants author consent copy as plain text in a single portal field shared with the
 * native apps, so links come from matching known phrases rather than markup — iOS reads
 * the same entry into an NSAttributedString and would show any HTML tags verbatim.
 * These are the phrases the native apps search for, case-sensitive and first-occurrence
 * only to mirror their `range(of:)` calls, plus General Notice which is web-only so far.
 */
const MODAL_NAMES_BY_PHRASE = {
  'Privacy Policy': 'privacyPolicy',
  'Terms & Conditions': 'termsAndConditions',
  'General Notice': 'generalNotice'
};


export function splitLegalPhrases(content) {
  if (!content) return [];

  const matches = Object.entries(MODAL_NAMES_BY_PHRASE)
    .map(([phrase, modalName]) => ({ phrase, modalName, index: content.indexOf(phrase) }))
    .filter(match => match.index !== -1)
    .sort((a, b) => a.index - b.index);

  const segments = [];
  let cursor = 0;

  matches.forEach(({ phrase, modalName, index }) => {
    if (index > cursor) segments.push({ text: content.slice(cursor, index) });

    segments.push({ text: phrase, modalName });

    cursor = index + phrase.length;
  });

  if (cursor < content.length) segments.push({ text: content.slice(cursor) });

  return segments;
}
